module.exports = __webpack_public_path__ + "img/bvs_logo_es.011a2f45.svg";